// extracted by mini-css-extract-plugin
export var container = "_py-0";
export var dotAnimation = "_py-2";
export var dotsLoading = "_py-1";